import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/free-regular-svg-icons';
// components/BottomSheet/OverviewBottomSheet.js
import React, { useEffect, useState } from 'react';
import '../styles/overview.css';

const URL = `${process.env.REACT_APP_API_BASE}/`;

const OverviewBottomSheet = ({ isOpen, onClose, onBookmark, projectData }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [announcements, setAnnouncements] = useState([]);
  const [loadingAnnouncements, setLoadingAnnouncements] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(false);
  // Fetch announcements for the project
  useEffect(() => {
    const projectId = projectData?.id;
    const projectType = "announcement"; // Assuming a fixed type for now, adjust as needed
    // console.log('Fetching announcements for project:', projectId, 'type:', projectType);
    if (!isOpen || !projectId) {
      setAnnouncements([]);
      return;
    }
    setLoadingAnnouncements(true);
    fetch(`${URL}api/anouncements/?id=${projectId}&limit=100&offset=0&project_type=${projectType}`)
      .then(res => res.json())
      .then(data => {
        setAnnouncements(Array.isArray(data?.results) ? data.results : []);
      })
      .catch(() => setAnnouncements([]))
      .finally(() => setLoadingAnnouncements(false));
  }, [isOpen, projectData]);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
      document.body.style.overflow = 'hidden';
    } else {
      setIsVisible(false);
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300); // Match animation duration
  };

  if (!isOpen) return null;

  // Fallbacks for missing data
  const title = projectData?.name || 'Untitled Project';
  const code = projectData?.code || 'N/A';
  const location = projectData?.location || '';
  const description = projectData?.description || 'No description available.';
  const status = projectData?.status || 'Unknown';
  const client = projectData?.company || 'Unknown company';
  const type = projectData?.type || 'General';
  const startDate = projectData?.startDate || projectData?.start_date || 'N/A';

  return (
    <>
      <div
        className={`overlay ${isVisible ? 'visible' : ''}`}
        onClick={handleClose}
      />
      <div className={`overview-bottom-sheet ${isVisible ? 'visible' : ''}`}>
        <div className="sheet-handle" onClick={handleClose}>
          <div className="handle-bar" />
        </div>
        <div className="sheet-content">
          {/* Header */}

          <div className="overview-header">
            <h2 className="overview-title">Project Overview</h2>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              {/* Show Bookmark button only if no announcements */}
              {(!loadingAnnouncements && announcements.length === 0) && (
                <button className="overview-bookmark" title="Bookmark project" onClick={() => { setIsBookmarked(b => !b); onBookmark(); }} style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: 4, padding: 0 }}>
                  <FontAwesomeIcon icon={faBookmark} className={`bookmark-fa-icon${isBookmarked ? ' bookmarked' : ''}`} style={{ transition: 'color 0.2s' }} />
                </button>
              )}
              <button className="overview-close" onClick={handleClose}>×</button>
            </div>
          </div>

          {/* Project Title */}
          <h3 className="project-main-title">{title}</h3>

          {/* Project ID and Location */}
          <div className="project-meta">
            <span className="project-id">{code}</span>
            {location && <span className="project-location">{location}</span>}
          </div>

          {/* Description */}
          <div className="description-section">
            <h4 className="section-label">Description</h4>
            <p className="description-text">{description}</p>
          </div>

          {/* Details Grid */}
          <div className="details-grid">
            {/* <div className="detail-item">
              <span className="detail-label">Start Date</span>
              <span className="detail-value">{startDate}</span>
            </div>
            <div className="detail-item">
              <span className="detail-label">Status</span>
              <span className="detail-value status-completed">{status}</span>
            </div> */}
            {/* Company */}
            <div className="detail-item">
              <span className="detail-label">Company</span>
              <span className="detail-value">{client}</span>
            </div>
          </div>

          {/* Next button below company if announcements exist */}
          {(!loadingAnnouncements && announcements.length > 0) && (
            <div style={{ width: '100%', margin: '12px 0 0 0' }}>
              <button className="overview-next" onClick={() => onClose('next', announcements[0])} style={{ width: '100%', padding: '12px 0', borderRadius: '8px', background: 'var(--color-primary)', color: '#fff', border: 'none', fontWeight: 600, fontSize: 16, cursor: 'pointer' }}>Next</button>
            </div>
          )}
          {/* <div style={{ width: '100%', margin: '12px 0 0 0' }}>
            <button className="overview-next" onClick={() => onClose('next', announcements[0])} style={{ width: '100%', padding: '12px 0', borderRadius: '8px', background: 'var(--color-primary)', color: '#fff', border: 'none', fontWeight: 600, fontSize: 16, cursor: 'pointer' }}>Next</button>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default OverviewBottomSheet;